<div class="headline-6 mb-1 mt-3">Fundraisers Report</div>
@if(!fundraisersReport || fundraisersReport.length === 0){
    <div class="p-5 body-1 text-center">No fundraisers yet.</div>
} @else{
    <div class="table--paybee" >
        <table class="table" cellspacing="0" style="width: 100%; background-color: white;"
            datatable #fundraisersReportDatatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead class="thead-light">
            <tr>
                <th class="text-nowrap">Fundraiser Name</th>
                <th class="text-nowrap">Donor Name</th>
                <th class="text-nowrap">Donor Email</th>
                @if(typeData.campaignTypeData.teamEnabled){
                    <th class="text-nowrap">Team</th>
                }
                <th class="text-nowrap">Option Name </th>
                <th class="text-nowrap">Goal</th>
                @if(!typeData.pledgePerEvent){
                    <th class="text-nowrap">Total Raised</th>
                } @else{
                    <th class="text-nowrap">Total Pledges</th>
                    <th class="text-nowrap">Milestones</th>
                }
                <th class="text-nowrap">Phone </th>
                <th class="text-nowrap">Address</th>
                <th class="text-nowrap">Created Date</th>
                <th class="text-nowrap">Donate Link</th>
            </tr>
            </thead>
        </table>
    </div>
}
